// ---------------------------------------------
// auto-generated from screens/explica.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { Icon, Chip, Eyebrow, ObjectiveBar, SourceRail, StatusBar, Candles, genCandles, NotAdvice } from "./primitives.jsx";

export const EX_DATA = (seed = 31) => genCandles(48, seed, { trend: 0.7, vol: 1.3, base: 100 });

// shared chrome
export const ExplicaTopBar = ({ act = "A3", time = "02:14 / 07:00", subtitle = "¿Qué confirmaría la ruptura?" }) => (
  <div style={{ padding: "0 18px", display: "flex", flexDirection: "column", gap: 6 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <Chip>EXPLICA · medio · 7 min</Chip>
      <Chip variant="live">live case</Chip>
      <span className="mono"
            style={{ marginLeft: "auto", fontSize: 10.5, color: "var(--text-3)", letterSpacing: "0.08em" }}>{time}</span>
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
      <span className="mono" style={{ fontSize: 10, letterSpacing: "0.14em", color: "var(--accent)", textTransform: "uppercase" }}>
        Acto · {act}
      </span>
      <span style={{ fontSize: 12, color: "var(--text-2)" }}>· {subtitle}</span>
    </div>
  </div>
);

export const ExplicaSourceRailEdu = () => (
  <div style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}>
    <SourceRail source="vendor_primary · XYZ 1D" time="14:32 UTC"/>
  </div>
);

// ─────────────────────────────────────────────────────────
//  1. Explica / Player / Intro
// ─────────────────────────────────────────────────────────
export const ScreenExplicaIntro = () => (
  <div className="screen-m ef" data-screen-label="Explica · Intro">
    <StatusBar/>
    {/* Back */}
    <div style={{ padding: "0 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="back" size={14}/></button>
      <Chip>EXPLICA · medio · 7 min</Chip>
      <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="more" size={14}/></button>
    </div>

    <div style={{ padding: "18px 22px 0" }}>
      <Eyebrow>Ruptura o falsa ruptura</Eyebrow>
      <div style={{ fontSize: 28, fontWeight: 600, lineHeight: 1.1, letterSpacing: "-0.025em", marginTop: 8, textWrap: "balance" }}>
        Soportes, resistencias y <span style={{ color: "var(--accent)" }}>volumen</span>.
      </div>

      <div className="glass" style={{ marginTop: 16, padding: 14, borderRadius: 14 }}>
        <div className="mono" style={{ fontSize: 10, letterSpacing: "0.14em", color: "var(--primary)", textTransform: "uppercase" }}>Pregunta guía</div>
        <div style={{ fontSize: 15, marginTop: 6, lineHeight: 1.35, textWrap: "pretty" }}>
          ¿Cómo distingo una ruptura sólida de una falsa ruptura?
        </div>
      </div>

      <div style={{ marginTop: 18 }}>
        <Eyebrow>En 7 minutos serás capaz de</Eyebrow>
        <ul style={{ listStyle: "none", padding: 0, marginTop: 8, display: "flex", flexDirection: "column", gap: 8 }}>
          {[
            "Dibujar soportes y resistencias como zonas",
            "Distinguir cruce, cierre y confirmación",
            "Usar volumen como evidencia",
            "Clasificar falsas rupturas sin sesgo",
          ].map((t, i) => (
            <li key={i} style={{ display: "flex", gap: 10, alignItems: "flex-start", fontSize: 13.5, color: "var(--text)", lineHeight: 1.35 }}>
              <span style={{ width: 5, height: 5, borderRadius: 99, background: "var(--accent)", marginTop: 8, flexShrink: 0 }}></span>
              {t}
            </li>
          ))}
        </ul>
      </div>

      <div style={{ marginTop: 16, display: "flex", gap: 8 }}>
        <div className="glass" style={{ flex: 1, padding: 10, borderRadius: 10 }}>
          <span className="mono" style={{ fontSize: 9.5, letterSpacing: "0.12em", color: "var(--text-3)" }}>NECESITAS</span>
          <div style={{ fontSize: 12, marginTop: 4 }}>Soportes y resistencias · básico</div>
        </div>
        <div className="glass" style={{ flex: 1, padding: 10, borderRadius: 10 }}>
          <span className="mono" style={{ fontSize: 9.5, letterSpacing: "0.12em", color: "var(--text-3)" }}>NECESITAS</span>
          <div style={{ fontSize: 12, marginTop: 4 }}>Volumen básico</div>
        </div>
      </div>

      <div style={{ marginTop: 18 }}>
        <Eyebrow>Render mode</Eyebrow>
        <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
          {[
            { i: "movie", l: "Movie", on: true },
            { i: "explore", l: "Explore" },
            { i: "book", l: "Reading" },
            { i: "headset", l: "Audio" },
          ].map((m, i) => (
            <button key={i} className="btn ghost sm" style={{
              flex: 1, height: 36, padding: "0 6px", gap: 5,
              borderColor: m.on ? "var(--primary)" : "var(--line)",
              background: m.on ? "rgba(127,182,255,0.12)" : "rgba(168,185,217,0.04)",
              color: m.on ? "var(--text)" : "var(--text-2)",
            }}>
              <Icon name={m.i} size={13} style={{ color: m.on ? "var(--primary)" : "var(--text-3)" }}/>
              <span style={{ fontSize: 11.5 }}>{m.l}</span>
            </button>
          ))}
        </div>
      </div>
    </div>

    {/* CTA */}
    <div style={{ position: "absolute", bottom: 36, left: 18, right: 18 }}>
      <button className="btn primary" style={{ width: "100%" }}><Icon name="play" size={13}/> Empezar</button>
      <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
        <NotAdvice/>
      </div>
    </div>
  </div>
);

// ─────────────────────────────────────────────────────────
//  2. Explica / Player / Act  · A3
// ─────────────────────────────────────────────────────────
export const ScreenExplicaAct = () => {
  const data = React.useMemo(() => EX_DATA(15), []);
  return (
    <div className="screen-m ef" data-screen-label="Explica · Player · A3">
      <StatusBar/>
      <ExplicaTopBar/>
      <div style={{ padding: "10px 18px 0" }}>
        <ObjectiveBar eye="Pregunta del usuario">¿Qué confirmaría la ruptura?</ObjectiveBar>
      </div>

      {/* host visual: price + volume + events */}
      <div style={{ padding: "12px 18px 0" }}>
        <div className="glass" style={{ borderRadius: 14, overflow: "hidden" }}>
          <div style={{ padding: "10px 12px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div className="mono" style={{ fontSize: 10.5, color: "var(--text)", letterSpacing: "0.04em" }}>XYZ · 1D</div>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--text-3)", marginTop: 2 }}>price · volume · events</div>
            </div>
            <div style={{ display: "flex", gap: 6 }}>
              <Chip variant="neutral">R · 101.5</Chip>
              <Chip variant="live">+vol</Chip>
            </div>
          </div>
          <Candles
            data={data}
            width={354} height={260} padding={8}
            showVolume={true}
            overlays={[
              { type: "zone", from: 100.6, to: 102.2, color: "primary", label: "ZONA R" },
              { type: "marker", x: 34, y: 103.8, label: "cierre fuera" },
              { type: "line", y: 100.0, color: "rgba(127,182,255,0.4)", dashed: true },
            ]}/>
        </div>
      </div>

      {/* Beats reveal (3 stagger) */}
      <div style={{ padding: "14px 18px 0", display: "flex", flexDirection: "column", gap: 8 }}>
        {[
          { c: "var(--primary)", n: "01", t: "Zona R con 3 toques previos" },
          { c: "var(--accent)", n: "02", t: "Cierre por encima de la zona" },
          { c: "var(--accent)", n: "03", t: "Volumen relativo +60% sobre media" },
        ].map((b, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span className="mono" style={{ fontSize: 10.5, color: b.c, letterSpacing: "0.08em" }}>{b.n}</span>
            <span style={{ flex: 1, height: 1, background: `color-mix(in oklab, ${b.c} 35%, transparent)` }}></span>
            <span style={{ fontSize: 12.5, color: "var(--text)", lineHeight: 1.3, textWrap: "pretty" }}>{b.t}</span>
          </div>
        ))}
      </div>

      {/* chapter timeline + controls */}
      <div style={{ position: "absolute", bottom: 100, left: 18, right: 18 }}>
        <div className="glass" style={{ padding: "10px 12px", borderRadius: 12 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            {["A1","A2","A3","A4","A5","A6","A7"].map((a, i) => (
              <div key={i} style={{
                flex: 1, height: 4, borderRadius: 2,
                background: i < 2 ? "var(--accent)" : i === 2 ? "var(--text)" : "rgba(168,185,217,0.18)",
                position: "relative",
              }}>
                {i === 2 && <span style={{
                  position: "absolute", top: -3, left: "70%", width: 10, height: 10, borderRadius: 99,
                  background: "var(--text)", border: "2px solid var(--bg)",
                }}/>}
              </div>
            ))}
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10, alignItems: "center" }}>
            <span className="mono" style={{ fontSize: 10, color: "var(--text-3)" }}>3 freeze marks</span>
            <div style={{ display: "flex", gap: 8 }}>
              <button className="icon-btn" style={{ width: 32, height: 32 }}><Icon name="cc" size={14}/></button>
              <button className="icon-btn" style={{ width: 32, height: 32 }}><Icon name="freeze" size={14}/></button>
              <button className="icon-btn primary" style={{ width: 32, height: 32, background: "rgba(127,182,255,0.18)" }}><Icon name="pause" size={14}/></button>
            </div>
          </div>
        </div>
      </div>

      <ExplicaSourceRailEdu/>
    </div>
  );
};

// ─────────────────────────────────────────────────────────
//  3. Explica / Player / Freeze
// ─────────────────────────────────────────────────────────
export const ScreenExplicaFreeze = () => {
  const data = React.useMemo(() => EX_DATA(15), []);
  return (
    <div className="screen-m ef" data-screen-label="Explica · Freeze">
      <StatusBar/>
      {/* dimmed background */}
      <div style={{ position: "absolute", inset: 0, background: "rgba(6,15,34,0.5)", zIndex: 1 }}/>

      <div style={{ padding: "0 18px", position: "relative", zIndex: 2 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Chip variant="warn">
            <Icon name="snowflake" size={10}/> congelado · 03:18
          </Chip>
          <span className="mono" style={{ fontSize: 10, color: "var(--text-3)" }}>valores con timestamp</span>
        </div>
      </div>

      {/* Frozen host visual with ring */}
      <div style={{ padding: "12px 18px 0", position: "relative", zIndex: 2 }}>
        <div style={{
          borderRadius: 16, padding: 1,
          background: "linear-gradient(135deg, rgba(127,182,255,0.55), rgba(95,214,193,0.55), rgba(127,182,255,0.1))"
        }}>
          <div className="glass" style={{ borderRadius: 15, overflow: "hidden" }}>
            <div style={{ padding: "10px 12px", display: "flex", justifyContent: "space-between" }}>
              <div className="mono" style={{ fontSize: 10.5, color: "var(--text)" }}>XYZ · 1D · 14:32 UTC</div>
              <div className="mono" style={{ fontSize: 10.5, color: "var(--accent)" }}>● fixed</div>
            </div>
            <Candles data={data} width={354} height={180} padding={8} showVolume={true}
              overlays={[
                { type: "zone", from: 100.6, to: 102.2, color: "primary", label: "R" },
                { type: "marker", x: 34, y: 103.8, label: "decision" },
              ]}/>
          </div>
        </div>
      </div>

      {/* Context menu */}
      <div style={{ padding: "16px 18px 0", position: "relative", zIndex: 2 }}>
        <Eyebrow>Acciones contextuales</Eyebrow>
        <div style={{ marginTop: 8, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          {[
            { i: "draw", t: "Dibujar zona" },
            { i: "tag", t: "Etiquetar swings" },
            { i: "compare", t: "Comparar caso" },
            { i: "play", t: "Replay vela a vela" },
            { i: "link", t: "Abrir fuente" },
            { i: "help", t: "Preguntar al tutor" },
            { i: "book", t: "Glosario" },
            { i: "save", t: "Guardar repaso" },
          ].map((a, i) => (
            <button key={i} className="glass" style={{
              border: "1px solid var(--line)", padding: "10px 12px", borderRadius: 10,
              display: "flex", alignItems: "center", gap: 8, color: "var(--text)",
              background: "rgba(23,42,79,0.7)", textAlign: "left", cursor: "pointer"
            }}>
              <Icon name={a.i} size={14} style={{ color: "var(--primary)" }}/>
              <span style={{ fontSize: 12.5 }}>{a.t}</span>
            </button>
          ))}
        </div>
      </div>

      {/* resume */}
      <div style={{ position: "absolute", bottom: 80, left: 18, right: 18, zIndex: 3 }}>
        <button className="btn primary" style={{ width: "100%" }}>
          <Icon name="play" size={13}/> Reanudar exactamente desde 03:18
        </button>
      </div>
      <ExplicaSourceRailEdu/>
    </div>
  );
};

// ─────────────────────────────────────────────────────────
//  4. Explica / Player / Lab  (draw_zone)
// ─────────────────────────────────────────────────────────
export const ScreenExplicaLab = () => {
  const data = React.useMemo(() => EX_DATA(23), []);
  return (
    <div className="screen-m ef" data-screen-label="Explica · Lab · DrawZone">
      <StatusBar/>
      <div style={{ padding: "0 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="x" size={14}/></button>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Chip>LAB · ejercicio 3 de 4</Chip>
        </div>
        <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="more" size={14}/></button>
      </div>

      <div style={{ padding: "16px 18px 0" }}>
        <Eyebrow>Draw zone · resistencia</Eyebrow>
        <div style={{ fontSize: 17, fontWeight: 600, lineHeight: 1.25, marginTop: 6, letterSpacing: "-0.01em", textWrap: "balance" }}>
          Dibuja la <span style={{ color: "var(--accent)" }}>zona de resistencia</span> más relevante.
        </div>
      </div>

      {/* Toolbar */}
      <div style={{ padding: "12px 18px 0" }}>
        <div className="glass" style={{ padding: "6px", borderRadius: 10, display: "flex", gap: 4 }}>
          <button className="btn ghost sm" style={{ flex: 1, background: "rgba(95,214,193,0.18)", borderColor: "var(--accent)", color: "var(--accent)" }}><Icon name="draw" size={13}/> Zona</button>
          <button className="btn ghost sm" style={{ flex: 1 }}><Icon name="tag" size={13}/> Etiqueta</button>
          <button className="btn ghost sm" style={{ flex: 1 }}><Icon name="compare" size={13}/> Compare</button>
          <button className="btn ghost sm" style={{ width: 40, padding: 0 }}><Icon name="ind" size={13}/></button>
        </div>
      </div>

      {/* Chart with user-drawn zone preview */}
      <div style={{ padding: "10px 18px 0" }}>
        <div className="glass" style={{ borderRadius: 12, overflow: "hidden", position: "relative" }}>
          <Candles data={data} width={354} height={260} padding={8}
            overlays={[
              { type: "zone", from: 100.8, to: 102.4, color: "accent", label: "tu zona" },
            ]}/>
          {/* crosshair + price label */}
          <div style={{
            position: "absolute", top: 90, left: 8, right: 8, height: 1,
            background: "linear-gradient(90deg, rgba(95,214,193,0.6), transparent)",
            pointerEvents: "none"
          }}/>
          <div style={{
            position: "absolute", right: 12, top: 80,
            fontFamily: "var(--t-mono)", fontSize: 10, color: "var(--accent)",
            background: "rgba(6,15,34,0.85)", padding: "2px 6px", borderRadius: 4,
            border: "1px solid rgba(95,214,193,0.35)"
          }}>102.4</div>
          <div style={{
            position: "absolute", right: 12, top: 130,
            fontFamily: "var(--t-mono)", fontSize: 10, color: "var(--accent)",
            background: "rgba(6,15,34,0.85)", padding: "2px 6px", borderRadius: 4,
            border: "1px solid rgba(95,214,193,0.35)"
          }}>100.8</div>
        </div>
      </div>

      {/* Tool actions */}
      <div style={{ position: "absolute", bottom: 168, left: 18, right: 18, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", gap: 6 }}>
          <button className="btn ghost sm" style={{ height: 32 }}><Icon name="retry" size={12}/> Rehacer</button>
          <button className="btn ghost sm" style={{ height: 32 }}><Icon name="x" size={12}/> Limpiar</button>
        </div>
        <span className="mono" style={{ fontSize: 10, color: "var(--text-3)" }}>1 punto · alto 1.6</span>
      </div>

      {/* mini player + send */}
      <div style={{ position: "absolute", bottom: 90, left: 18, right: 18 }}>
        <div className="glass" style={{ borderRadius: 10, padding: "8px 10px", display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <Icon name="pause" size={14} style={{ color: "var(--text-2)" }}/>
          <div style={{ flex: 1, height: 3, background: "rgba(168,185,217,0.15)", borderRadius: 2, overflow: "hidden" }}>
            <div style={{ width: "57%", height: "100%", background: "var(--text-2)" }}></div>
          </div>
          <span className="mono" style={{ fontSize: 10, color: "var(--text-3)" }}>04:02 / 07:00</span>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn ghost sm" style={{ flex: 1 }}><Icon name="lightbulb" size={13}/> Pista 1/3</button>
          <button className="btn accent" style={{ flex: 1.4 }}><Icon name="check" size={13}/> Enviar zona</button>
        </div>
      </div>
      <ExplicaSourceRailEdu/>
    </div>
  );
};

// ─────────────────────────────────────────────────────────
//  5. Explica / Transfer / UnseenChart  (post-submit)
// ─────────────────────────────────────────────────────────
export const ScreenExplicaTransfer = () => {
  const data = React.useMemo(() => EX_DATA(45), []);
  return (
    <div className="screen-m ef" data-screen-label="Explica · Transferencia">
      <StatusBar/>
      <div style={{ padding: "0 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="back" size={14}/></button>
        <Chip variant="live">transferencia</Chip>
        <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="help" size={14}/></button>
      </div>

      <div style={{ padding: "16px 18px 0" }}>
        <Eyebrow>Gráfico no visto · aplica lo aprendido</Eyebrow>
        <div style={{ fontSize: 18, fontWeight: 600, lineHeight: 1.2, marginTop: 6, letterSpacing: "-0.01em", textWrap: "balance" }}>
          ¿Hay <span style={{ color: "var(--accent)" }}>ruptura</span>, espera o falsa?
        </div>
      </div>

      {/* unseen chart with user marks */}
      <div style={{ padding: "12px 18px 0" }}>
        <div className="glass" style={{ borderRadius: 12, overflow: "hidden" }}>
          <div style={{ padding: "8px 12px", display: "flex", justifyContent: "space-between" }}>
            <span className="mono" style={{ fontSize: 10, color: "var(--text-3)" }}>ABC · 1D · sin overlays</span>
            <span className="mono" style={{ fontSize: 10, color: "var(--text-3)" }}>tu trabajo</span>
          </div>
          <Candles data={data} width={354} height={170} padding={8}
            overlays={[
              { type: "zone", from: 101.2, to: 102.8, color: "accent" },
              { type: "marker", x: 38, y: 103.6, label: "ruptura" },
            ]}/>
        </div>
      </div>

      {/* feedback positive */}
      <div style={{ padding: "16px 18px 0" }}>
        <div style={{
          background: "linear-gradient(180deg, rgba(95,214,193,0.16), rgba(95,214,193,0.03))",
          border: "1px solid rgba(95,214,193,0.32)", borderRadius: 14, padding: "14px"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Icon name="check" size={16} style={{ color: "var(--accent)" }}/>
            <span className="mono" style={{ fontSize: 11, letterSpacing: "0.12em", color: "var(--accent)", textTransform: "uppercase" }}>Transferencia válida · 80% rubric</span>
          </div>
          <div style={{ fontSize: 13.5, marginTop: 8, lineHeight: 1.4, textWrap: "pretty" }}>
            Has integrado <span style={{ color: "var(--accent)" }}>nivel + cierre + volumen</span>. Misconception evitada: cruce ≠ ruptura.
          </div>

          {/* rubric chips */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 12 }}>
            {[
              { l: "nivel", on: true },
              { l: "cierre", on: true },
              { l: "volumen", on: true },
              { l: "contexto", on: false },
            ].map((r, i) => (
              <span key={i} className="chip" style={{
                background: r.on ? "rgba(95,214,193,0.14)" : "rgba(168,185,217,0.06)",
                borderColor: r.on ? "rgba(95,214,193,0.4)" : "var(--line)",
                color: r.on ? "var(--accent)" : "var(--text-3)",
              }}>
                <Icon name={r.on ? "check" : "circle"} size={9}/> {r.l}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* confidence delta */}
      <div style={{ padding: "12px 18px 0" }}>
        <div className="glass" style={{ padding: 14, borderRadius: 12 }}>
          <Eyebrow>Confianza declarada</Eyebrow>
          <div style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ flex: 1 }}>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--text-3)", letterSpacing: "0.1em" }}>ANTES</div>
              <div style={{ display: "flex", gap: 3, marginTop: 6 }}>
                {[0,1,2,3,4].map(i => (
                  <span key={i} style={{ width: 10, height: 10, borderRadius: 2, background: i < 2 ? "var(--text-2)" : "rgba(168,185,217,0.15)" }}></span>
                ))}
              </div>
            </div>
            <Icon name="next" size={14} style={{ color: "var(--accent)" }}/>
            <div style={{ flex: 1 }}>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--accent)", letterSpacing: "0.1em" }}>DESPUÉS</div>
              <div style={{ display: "flex", gap: 3, marginTop: 6 }}>
                {[0,1,2,3,4].map(i => (
                  <span key={i} style={{ width: 10, height: 10, borderRadius: 2, background: i < 4 ? "var(--accent)" : "rgba(168,185,217,0.15)" }}></span>
                ))}
              </div>
            </div>
            <div style={{ marginLeft: 6 }}>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--text-3)" }}>Δ</div>
              <div className="mono" style={{ fontSize: 16, color: "var(--accent)", fontWeight: 600 }}>+2</div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ position: "absolute", bottom: 50, left: 18, right: 18, display: "flex", gap: 8 }}>
        <button className="btn ghost sm" style={{ flex: 1 }}><Icon name="retry" size={13}/> Reintentar</button>
        <button className="btn primary sm" style={{ flex: 1.4 }}><Icon name="next" size={13}/> Siguiente: Recap</button>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────
//  6. Explica / Recap / EndCard
// ─────────────────────────────────────────────────────────
export const ScreenExplicaRecap = () => (
  <div className="screen-m ef" data-screen-label="Explica · Recap">
    <StatusBar/>
    <div style={{ padding: "0 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
      <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="x" size={14}/></button>
      <Chip>EXPLICA completado</Chip>
      <button className="icon-btn" style={{ width: 32, height: 32, borderRadius: 8 }}><Icon name="share" size={14}/></button>
    </div>

    <div style={{ padding: "18px 22px 0" }}>
      <Eyebrow>Resumen en 3 tarjetas</Eyebrow>
      <div style={{ fontSize: 22, fontWeight: 600, lineHeight: 1.15, marginTop: 6, letterSpacing: "-0.02em" }}>
        Ruptura o <span style={{ color: "var(--accent)" }}>falsa ruptura</span>
      </div>
    </div>

    <div style={{ padding: "18px 18px 0", display: "flex", flexDirection: "column", gap: 10 }}>
      {[
        { lbl: "CONCEPTO", c: "var(--primary)", t: "Soporte y resistencia son zonas, no líneas exactas." },
        { lbl: "EVIDENCIA", c: "var(--accent)", t: "Cierre + volumen relativo + contexto sostienen la ruptura." },
        { lbl: "CAUTELA",   c: "var(--warn)",   t: "Cruce ≠ ruptura. La confirmación llega tras el cierre." },
      ].map((c, i) => (
        <div key={i} className="glass" style={{ padding: 14, borderRadius: 12, borderLeft: `3px solid ${c.c}` }}>
          <div className="mono" style={{ fontSize: 10, letterSpacing: "0.14em", color: c.c }}>{c.lbl}</div>
          <div style={{ fontSize: 14, marginTop: 6, lineHeight: 1.3, textWrap: "pretty" }}>{c.t}</div>
        </div>
      ))}
    </div>

    {/* next node */}
    <div style={{ padding: "16px 18px 0" }}>
      <Eyebrow>Próximo nodo</Eyebrow>
      <div className="glass" style={{ marginTop: 8, padding: 12, borderRadius: 12, display: "flex", alignItems: "center", gap: 10, borderColor: "rgba(127,182,255,0.4)" }}>
        <div style={{ width: 36, height: 36, borderRadius: 9, background: "rgba(127,182,255,0.18)", display: "grid", placeItems: "center" }}>
          <Icon name="ind" size={15} style={{ color: "var(--primary)" }}/>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13.5, fontWeight: 600 }}>Volatilidad · ATR y Bollinger</div>
          <div className="mono" style={{ fontSize: 10, color: "var(--text-3)", marginTop: 2 }}>EXPLICA · 7 min</div>
        </div>
        <Icon name="next" size={16} style={{ color: "var(--primary)" }}/>
      </div>
    </div>

    {/* spaced */}
    <div style={{ padding: "14px 18px 0" }}>
      <Eyebrow>Repaso programado</Eyebrow>
      <div style={{ marginTop: 8, display: "flex", gap: 8 }}>
        {[
          { d: "mañana", t: "1 flashcard", i: "spark" },
          { d: "día 4", t: "micro-quiz", i: "list" },
          { d: "día 10", t: "transfer", i: "target" },
        ].map((s, i) => (
          <div key={i} className="glass" style={{ flex: 1, padding: 10, borderRadius: 10 }}>
            <div className="mono" style={{ fontSize: 9.5, letterSpacing: "0.1em", color: "var(--text-3)" }}>{s.d.toUpperCase()}</div>
            <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 6 }}>
              <Icon name={s.i} size={12} style={{ color: "var(--accent)" }}/>
              <span style={{ fontSize: 11.5 }}>{s.t}</span>
            </div>
          </div>
        ))}
      </div>
    </div>

    <div style={{ position: "absolute", bottom: 36, left: 18, right: 18 }}>
      <button className="btn primary" style={{ width: "100%" }}>
        <Icon name="next" size={13}/> Volatilidad · ATR y Bollinger
      </button>
      <div style={{ display: "flex", justifyContent: "center", marginTop: 10, gap: 12, alignItems: "center" }}>
        <NotAdvice/>
        <span style={{ fontSize: 9.5, color: "var(--text-3)" }}>·</span>
        <span className="mono" style={{ fontSize: 9.5, color: "var(--text-3)", letterSpacing: "0.08em" }}>vendor_primary · 14:32 UTC</span>
      </div>
    </div>
  </div>
);
